import React from 'react'
import img1 from '../../assets/images/ceo1.JPG';

import { FaLongArrowAltRight } from "react-icons/fa";

const OurVision = () => {
  return (
    
     
    <section className="py-10 lg:py-20">
        <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" data-aos="zoom-out-right">
                <div className='order-2 lg:order-1'>
                    <img src={img1} className="rounded-xl object-cover" alt="" />
                </div>

                <div className="p-3 md:p-6 order-1 lg:order-2">
                    
                    <h2 className="text-2xl md:text-4xl font-semibold text-[#182e55] mt-4">Our Vision</h2>
                    <p className="text-sm md:text-base text-gray-800 mt-5 leading-relaxed">At Yogesh Aluminium Ladder Manufacturing Company, our vision is to be the leading ladder manufacturer in the region, recognized for quality, safety, and innovation. We aim to continue evolving with industry needs, delivering solutions that elevate safety standards and contribute to the success of our customers.</p>

                    <div className="grid grid-cols-1 my-5 space-y-2 text-[15px] md:text-lg font-medium  text-gray-800">
                        <div className="flex items-center gap-2">
                            <div>
                                <FaLongArrowAltRight className="h-5 w-5 text-orange-600" />
                            </div>
                            <h3>Standard Quality</h3>
                        </div>

                        <div className="flex items-center  gap-2">
                            <div>
                            <FaLongArrowAltRight className="h-5 w-5  text-orange-600" />
                            </div>
                            <h3>Customization</h3>
                        </div>

                        <div className="flex items-center gap-2">
                            <div>
                            <FaLongArrowAltRight className="h-5 w-5 text-orange-600" />
                            </div>
                            <h3>Better Price</h3>

                        </div>
                    </div>

                    
                </div>
                
            </div>
             
        </div>
    </section>
    
  )
}

export default OurVision